export const isAppleDevice = () => {
  const ua = window.navigator.userAgent.toLowerCase();

  return /(iphone|ipod|ipad)/.test(ua);
};

export const isAndroidDevice = () => {
  const ua = window.navigator.userAgent.toLowerCase();

  return ua.includes('android');
};

export const isMobileDevice = () => isAppleDevice() || isAndroidDevice();
